
import { ActivityIndicator } from "react-native";
import { colorList } from "utils/colors";

const Spinner = ({ color = colorList.WHITE.primary, size = 'normal', style = {}}) => {

    return (
        <ActivityIndicator
            color={ color }
            size={ size }
            style={[
                style
            ]}
        />
    )
}

export default Spinner;